export const compareIdAndReturnObject = (list, id) => {
    if (id !== null && id !== undefined && id !== "") {
      let index = list && list?.findIndex(element => element?.code == id);
      return list !==undefined && list[index]
    }
  }
  
  export const compareTextAndReturnObject = (list, text) => {
    if (text !== null && text !== undefined && text !== "") {
      let index = list && list?.findIndex(element => element?.value == text);
      return list!==undefined && list[index]
    }
  }

//   export const numberCommaFormat = (number, toFixed = true , country="en-IN") => {
//     const options = {  maximumFractionDigits: 2   }
//     const formattedNumber = Intl.NumberFormat(country,options).format(toFixed ? Number(number)?.toFixed(2) : Number(number));
//     return "₹ " + formattedNumber;
// }

export const numberCommaFormat = (number, country = "en-IN") => {
    const options = { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    };
    const formattedNumber = Intl.NumberFormat(country, options).format(Number(number));
    return "₹ " + formattedNumber;
};

 export const numberCommaFormatCRDR = (value, country = "en-IN") => {
  if (value == null || value === "") return "₹ 0.00";

  // Convert to string and separate the number from CR/DR
  const match = String(value).trim().match(/^([\d.,-]+)\s*(CR|DR)?$/i);

  if (!match) return value; // fallback: return original if pattern doesn't match

  const numericPart = parseFloat(match[1].replace(/,/g, ""));
  const suffix = match[2] ? match[2].toUpperCase() : "";

  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };
  const formattedNumber = Intl.NumberFormat(country, options).format(numericPart);

  return `₹ ${formattedNumber}${suffix ? " " + suffix : ""}`;
};


  